export default __webpack_public_path__ + "static/media/3t.f9d23b43.jpg";